import { render, staticRenderFns } from "./ReceiptDetailView.vue?vue&type=template&id=872782e0"
import script from "./ReceiptDetailView.vue?vue&type=script&lang=js"
export * from "./ReceiptDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports